module.exports = __webpack_public_path__ + "img/yujing1.cc490161.png";